/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FollowsInputs */

const en_follows = /** @type {(inputs: FollowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follows`)
};

const de_follows = /** @type {(inputs: FollowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follower`)
};

/**
* | output |
* | --- |
* | "Follows" |
*
* @param {FollowsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const follows = /** @type {((inputs?: FollowsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FollowsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_follows(inputs)
	return de_follows(inputs)
});